<template>
    <header-bar id="order">
        <div id="my-order">
            <div id="my-order-header">
                <div class="swiper-tab">
                    <div
                        class="swiper-tab-item"
                        :class="{ 'active': orderNotDelivered }"
                        @click="clickOrderNotDelivered"
                    >
                        <div class="tab-icon-wrap" :class="{ 'tab-icon-wrap-active': orderNotDelivered }">
                            <img
                                class="tab-img"
                                :class="{ 'img-active': orderNotDelivered }"
                                :src="orderNotDelivered ? require('../../assets/order-tab-pending-active.png') : require('../../assets/order-tab-pending.png')"
                                alt=""
                            >
                        </div>
                        <div class="tab-text">未配送<span class="tab-count">({{ notDeliverCount }})</span></div>
                    </div>

                    <div
                        class="swiper-tab-item"
                        :class="{ 'active': orderDelivered }"
                        @click="clickOrderDelivered"
                    >
                        <div class="tab-icon-wrap" :class="{ 'tab-icon-wrap-active': orderDelivered }">
                            <img
                                class="tab-img"
                                :class="{ 'img-active': orderDelivered }"
                                :src="orderDelivered ? require('../../assets/order-tab-delivered-active.png') : require('../../assets/order-tab-delivered.png')"
                                alt=""
                            >
                        </div>
                        <div class="tab-text">已配送<span class="tab-count">({{ deliverCount }})</span></div>
                    </div>

                    <div
                        class="swiper-tab-item"
                        :class="{ 'active': orderFinishDelivered }"
                        @click="clickOrderFinishDelivered"
                    >
                        <div class="tab-icon-wrap" :class="{ 'tab-icon-wrap-active': orderFinishDelivered }">
                            <img
                                class="tab-img"
                                :class="{ 'img-active': orderFinishDelivered }"
                                :src="orderFinishDelivered ? require('../../assets/order-tab-finished-active.png') : require('../../assets/order-tab-finished.png')"
                                alt=""
                            >
                        </div>
                        <div class="tab-text">已完成<span class="tab-count">({{ finishCount }})</span></div>
                    </div>

                    <div
                        class="swiper-tab-item"
                        :class="{ 'active': orderCancelDelivered }"
                        @click="clickOrderCancelDelivered"
                    >
                        <div class="tab-icon-wrap" :class="{ 'tab-icon-wrap-active': orderCancelDelivered }">
                            <img
                                class="tab-img"
                                :class="{ 'img-active': orderCancelDelivered }"
                                :src="orderCancelDelivered ? require('../../assets/order-tab-cancelled-active.png') : require('../../assets/order-tab-cancelled.png')"
                                alt=""
                            >
                        </div>
                        <div class="tab-text">已取消<span class="tab-count">({{ cancelCount }})</span></div>
                    </div>
                </div>
            </div>
        </div>

        <order-not-delivered v-show="orderNotDelivered"/>
        <order-delivered v-show="orderDelivered"/>
        <order-finish-delivered v-show="orderFinishDelivered"/>
        <order-cancel-delivered v-show="orderCancelDelivered"/>
    </header-bar>
</template>

<script>
import HeaderBar from "../../components/HeaderBar";
import OrderNotDelivered from "./OrderDelivered/OrderNotDelivered";
import OrderCancelDelivered from "./OrderDelivered/OrderCancelDelivered";
import OrderDelivered from "./OrderDelivered/OrderDelivered";
import OrderFinishDelivered from "./OrderDelivered/OrderFinishDelivered";
import {GetOrderPackageAndNormalTotal} from "../../api/PackagePeriodOrder";

export default {
        name: "Order",
        components: {HeaderBar, OrderNotDelivered, OrderCancelDelivered, OrderDelivered, OrderFinishDelivered},

        data() {
            return {
                orderNotDelivered: true,
                orderCancelDelivered: false,
                orderDelivered: false,
                orderFinishDelivered: false,

                notDeliverCount: 0,
                deliverCount: 0,
                finishCount: 0,
                cancelCount: 0,
            }
        },

        mounted()
        {
            this.requestOrderCount();
        },
        methods: {
            clickOrderNotDelivered() {
                this.orderNotDelivered = true;
                this.orderDelivered = false;
                this.orderFinishDelivered = false;
                this.orderCancelDelivered = false;
            },
            clickOrderDelivered() {
                this.orderNotDelivered = false;
                this.orderDelivered = true;
                this.orderFinishDelivered = false;
                this.orderCancelDelivered = false;
            },
            clickOrderFinishDelivered() {
                this.orderNotDelivered = false;
                this.orderDelivered = false;
                this.orderFinishDelivered = true;
                this.orderCancelDelivered = false;
            },
            clickOrderCancelDelivered() {
                this.orderNotDelivered = false;
                this.orderDelivered = false;
                this.orderFinishDelivered = false;
                this.orderCancelDelivered = true;
            },

            requestOrderCount() {
              GetOrderPackageAndNormalTotal()
                .then((response) => {
                  if (response.code === this.$API_CODE.OK) {
                    this.notDeliverCount = response.data.notDeliveredNumber;
                    this.deliverCount = response.data.deliveredNumber;
                    this.finishCount = response.data.completedNumber;
                    this.cancelCount = response.data.canceledNumber;
                  }
                });
            }
        },

        activated() {
            this.requestOrderCount();
        }
    }
</script>

<style scoped lang="scss">
#order {
    background: linear-gradient(180deg, #fff7f8 0%, #fffdfd 220px, #f8f9fd 100%);
    min-height: 100vh;

    #my-order {
        width: 100%;
        padding: 1px 10px 24px;
        box-sizing: border-box;
    }

    #my-order-header {
        position: fixed;
        width: calc(100% - 20px);
        left: 10px;
        right: 10px;
        z-index: 10;
        background: #ffffff;
        border-radius: 17px;
        padding: 6px 0;
        box-sizing: border-box;
        box-shadow: 0 6px 15px rgba(43, 61, 104, 0.06);
        border: 0.5px solid #f3f4f8;

        .swiper-tab {
            width: 100%;
            display: flex;

            .swiper-tab-item {
                flex: 1;
                min-width: 0;
                text-align: center;
                line-height: 1.4;
                font-size: 14px;
                color: #95a1b8;
                padding: 9px 4px 11px;
                position: relative;
                border-right: 0.5px solid #eef1f6;
                box-sizing: border-box;
                background: #ffffff;
                border-radius: 13px;
                cursor: pointer;
                transition: all 0.2s ease;

                &:last-child {
                    border-right: 0;
                }

                .tab-icon-wrap {
                    width: 47px;
                    height: 47px;
                    margin: 0 auto 7px;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #f7f9fc;
                    transition: all 0.2s ease;

                    .tab-img {
                        width: 38px;
                        height: 38px;
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }

                    .img-active {
                        transform: scale(1.06);
                    }
                }

                .tab-icon-wrap-active {
                    background: #ffecee;
                }

                .tab-text {
                    font-size: 13px;
                    font-weight: 500;
                    white-space: nowrap;

                    .tab-count {
                        font-weight: 600;
                    }
                }
            }

            .active {
                color: #ef334e;
                background: linear-gradient(180deg, #fff6f8 0%, #fff1f3 100%);
                box-shadow: 0 6px 14px rgba(239, 51, 78, 0.16);

                &::after {
                    display: block;
                    content: '';
                    width: 28px;
                    height: 3px;
                    border-radius: 999px;
                    background: #ef334e;
                    position: absolute;
                    left: 50%;
                    bottom: 5px;
                    transform: translateX(-50%);
                }
            }
        }
    }
}
</style>